import React, { useEffect, useRef, useCallback } from 'react';
import './TimelineSentimentHover.css';

function TimelineSentimentHover({ minute, sentiment, position, onClose, onMouseEnter, onMouseLeave }) {
  const hoverRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (hoverRef.current && !hoverRef.current.contains(event.target)) {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  const getHoverTitle = useCallback(() => {
    return `Minute ${minute} - Sentiment Analysis`;
  }, [minute]);

  const renderSentimentItem = useCallback((item, index) => (
    <div key={index} className="sentiment-item">
      <div className="sentiment-item-header">
        <span className="sentiment-type">{item.sentiment}</span>
        <span className="sentiment-confidence">{Math.round(item.confidence * 100)}%</span>
      </div>
      <div className="sentiment-item-content">
        <div className="sentiment-definition">
          <strong>Definition:</strong> {item.definition}
        </div>
        <div className="sentiment-analysis">
          <strong>Analysis:</strong> {item.analysis}
        </div>
        {item.transcriptContext && (
          <div className="sentiment-context">
            <strong>Context:</strong> "{item.transcriptContext}"
          </div>
        )}
      </div>
    </div>
  ), []);

  const renderSentimentItems = useCallback(() => {
    if (!sentiment || sentiment.length === 0) {
      return (
        <div className="sentiment-empty">
          <p>No sentiment data available for this minute.</p>
        </div>
      );
    }
    
    return sentiment.map((item, index) => renderSentimentItem(item, index));
  }, [sentiment, renderSentimentItem]);

  const getHoverStyle = useCallback(() => {
    return {
      left: `${position.x}px`,
      top: `${position.y}px`,
      transform: 'translateX(-50%) translateY(-100%)'
    };
  }, [position]);

  return (
    <div 
      ref={hoverRef}
      className="timeline-sentiment-hover"
      style={getHoverStyle()}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="timeline-sentiment-hover-header">
        <h4>{getHoverTitle()}</h4>
        <button 
          className="timeline-sentiment-hover-close"
          onClick={onClose}
          title="Close"
        >
          <i className="ti ti-x"></i>
        </button>
      </div>
      <div className="timeline-sentiment-hover-content">
        {renderSentimentItems()}
      </div>
      <div className="timeline-sentiment-hover-arrow"></div>
    </div>
  );
}

export default TimelineSentimentHover;
